import { useMemo } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { LocationSelectorModalController } from './location-selector-modal.controller';

const LocationSelectorModal = NiceModal.create(LocationSelectorModalController);

export const useLocationSelectorModal = () => {
  const { show } = useModal(LocationSelectorModal);
  return useMemo(() => ({ open: () => show() }), [show]);
};
